import bulgarian from "./messages/bg";
import english from "./messages/en";
import spanish from "./messages/es";
import japan from "./messages/ja";
import portuguese from "./messages/pt";

export const messages = {
  en: english,
  ja: japan,
  bg: bulgarian,
  es: spanish,
  pt: portuguese,
};
